import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Eye icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Eye } from '@sravni/design-system-icons'
 *
 * <Eye />
 * ```
 */
var Eye = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Eye", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.143 10S5 4.286 10 4.286 17.857 10 17.857 10 15 15.714 10 15.714 2.143 10 2.143 10Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10 12.143a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Eye };
//# sourceMappingURL=Eye.js.map
